import React from 'react';
import DatePicker from 'react-multi-date-picker';
import DateObject from 'react-date-object';
import persian from 'react-date-object/calendars/persian';
import persianFa from 'react-date-object/locales/persian_fa';

interface PersianMonthPickerFaProps {
  /** فرمت API: 1404-01 */
  value: string;
  onChange: (monthApi: string) => void;
  placeholder?: string;
  inputClassName?: string;
}

function normalizeDigits(value: string): string {
  return value.replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d)));
}

/** 1404-01 → DateObject اول ماه */
function monthToDateObject(value: string): DateObject | undefined {
  const v = normalizeDigits(value).replace(/\//g, '-');
  const m = v.match(/^(\d{4})-(\d{1,2})$/);
  if (!m) return undefined;
  const month = String(Number(m[2])).padStart(2, '0');
  return new DateObject({
    date: `${m[1]}/${month}/01`,
    format: 'YYYY/MM/DD',
    calendar: persian,
    locale: persianFa,
  });
}

/** DateObject → 1404-01 */
export function monthPickerToApi(dateObj: DateObject): string {
  const raw = normalizeDigits(dateObj.format('YYYY/MM'));
  const m = raw.match(/^(\d{4})\/(\d{1,2})$/);
  if (!m) return raw.replace('/', '-');
  return `${m[1]}-${String(Number(m[2])).padStart(2, '0')}`;
}

/** 1404-01 → 1404/01 برای نمایش */
export function monthApiToDisplay(value: string): string {
  return normalizeDigits(value).replace(/-/g, '/');
}

const DEFAULT_INPUT_CLASS =
  'w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';

const PersianMonthPickerFa: React.FC<PersianMonthPickerFaProps> = ({
  value,
  onChange,
  placeholder = 'انتخاب ماه…',
  inputClassName = DEFAULT_INPUT_CLASS,
}) => (
  <DatePicker
    value={monthToDateObject(value)}
    onChange={(d) => {
      if (!d) {
        onChange('');
        return;
      }
      const dateObj = Array.isArray(d) ? d[0] : d;
      if (!dateObj) {
        onChange('');
        return;
      }
      onChange(monthPickerToApi(dateObj));
    }}
    onlyMonthPicker
    calendar={persian}
    locale={persianFa}
    format="YYYY/MM"
    calendarPosition="bottom-right"
    containerClassName="w-full"
    inputClass={inputClassName}
    placeholder={placeholder}
  />
);

export default PersianMonthPickerFa;
